import { Breadcrumb } from 'antd';
import { FileProtectOutlined, HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const CareProtocolPageBreadCrumb = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Breadcrumb
      items={[
        {
          onClick: () => {
            navigate('/');
          },
          title: (
            <span style={{ cursor: 'pointer' }}>
              <HomeOutlined style={{ marginRight: 4 }} />
              <span>{t('breadcrumb.admin')}</span>
            </span>
          ),
        },
        {
          title: (
            <>
              <FileProtectOutlined />
              <span>{t('menu.careProtocols')}</span>
            </>
          ),
        },
      ]}
    />
  );
};
